import { preloadTasksQuery } from "./fetch-company-tasks";
import { preloadCurrentCompanyQuery } from "@/entities/company/api/fetch-my-companies-query";

export const preloadTaskOverviewQueries = (companyId: string) => {
  preloadTasksQuery({
    companyId,
    input: {
      searchQuery: "",
      labels: [],
      assignees: [],
      paginator: { take: 50, page: 1 },
    },
  });

  preloadCurrentCompanyQuery({ companyId });
};
